<template>
  <div
    v-if="currentComponent"
    class="opple-ability-ui-com"
  >
    <div class="opple-ability-ui-com-container">
      <div class="opple-ability-ui-com-label">
        {{ item.Desc }}
        <span
          v-show="tag"
          class="opple-ability-ui-com-tag"
          :class="tag.class"
        >
          {{ tag.text }}
        </span>
      </div>
      <div class="opple-ability-ui-com-info" :style="{ width: containerWidth + 'px'}">
        <component
          :is="currentComponent"
          ref="com"
          :item="item"
          :ui="ui"
          :gp-details="gpDetails"
          :device="device"
          :action-list="actionList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImageEnumType from './components/ImageEnumType.vue';
import TimeRangeType from './components/TimeRangeType.vue';
import UIControlImageIconEnumType from './components/UIControlImageIconEnumType.vue';
import Input from './components/Input.vue';
import InputNumber from './components/InputNumber.vue';
import FloatInput from './components/FloatInput.vue';
import TimeSingleType from './components/TimeSingleType.vue';
import TimeRangeTypeWithReset from './components/TimeRangeTypeWithReset.vue';
import UIControl_MultiIChildDevice from './components/UIControl_MultiIChildDevice.vue';
import UIControl_Slider from './components/UIControl_Slider.vue';

// import UIControlImageIconEnumType from './components/UIControlImageIconEnumType.vue';
import { v4 as uuid } from "uuid";

export default {
  name: 'OppleAbilityUiCom',
  comments: {
    ImageEnumType,
    TimeRangeType,
    TimeSingleType,
    TimeRangeTypeWithReset
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    ui: {
      type: Object,
      default: () => ({})
    },
    gpDetails: {
      type: Object,
      default: () => ({})
    },
    device: {
      type: Object,
      default: () => ({})
    },
    actionList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tag: {},
      comKey: uuid(),
      currentComponent: null, // 默认渲染ComponentA
      containerWidth: 218,
      // reset: false,
      bigInfoContainer: false
    };
  },

  computed: {

  },

  watch: {
    item(value) {
      this.setCom();
    }
  },

  mounted() {
    // console.log('mounted 3 ~~~~', this.item);
    this.setCom();
  },

  methods: {
    setCom() {
      const { ValueType, ResultCode, ParaType, Desc } = this.item;
      switch (ResultCode) {
        case 0:
          this.tag = {
            class: 'pedding',
            text: this.$t('deviceMsg.configing')
          }
          break;
        case 1:
          this.tag = {
            class: 'success',
            text: this.$t('deviceMsg.configsuccess')
          }
          break;
        case 2:
          this.tag = {
            class: 'fail',
            text: this.$t('deviceMsg.configfail')
          }
          break;
        default:
          this.tag = {
            class: 'default',
            text: this.$t('deviceMsg.configdefault')
          }
      }

      this.containerWidth = 218;
      switch (ValueType) {
        case 'UIControl_MultiIChildDevice':
          this.currentComponent = UIControl_MultiIChildDevice;
          this.containerWidth = 600;
          break;
        case 'UIControl_TimePicker':
          this.currentComponent = TimeSingleType;
          break;
        case 'UIControl_ImageEnumType':
          this.currentComponent = ImageEnumType;
          break;
        case  'UIControl_TimeRangeType':
          this.currentComponent = TimeRangeType;
          break;
        case  'UIControl_ResetTime':
          this.containerWidth = 400;
          this.currentComponent = TimeRangeTypeWithReset;
          break;
        case 'UIControl_ImageIconEnumType':
          this.currentComponent = UIControlImageIconEnumType;
          break;
        case 'Input':
          if (ParaType === 'String') {
            this.currentComponent = Input;
          } else {
            this.currentComponent = InputNumber;
          }
          break;
        case 'FloatInput':
          this.currentComponent = FloatInput;
          break;
        case 'UIControl_Slider':
          this.currentComponent = UIControl_Slider;
          //this.containerWidth = 320;
          break;
      }

      this.comKey = uuid();
    },

    getData() {
      if (
        this.$refs.com &&
        this.$refs.com.getData instanceof Function
      ) {
        return this.$refs.com.getData();
      }

      return {};
    },

    validate() {
      if (
        this.$refs.com &&
        this.$refs.com.validate instanceof Function
      ) {

        return this.$refs.com.validate();
      }

      return {
        status: true
      };
    },

    onSave() {
      if (
        this.$refs.com &&
        this.$refs.com.onSave instanceof Function
      ) {

        return this.$refs.com.onSave();
      }
    }
  },
};
</script>

<style lang="scss">
.opple-ability-ui-com {
  .opple-ability-ui-com-container {
    display: flex;
    justify-content: space-between;
  }

  .opple-ability-ui-com-tag {
    font-size: 12px;
    border-radius: 4px;
    padding: 0 4px;
    margin-left: 8px;

    &.success {
      border: 1px solid #67c23a;
      color: #67c23a;
    }

    &.pedding {
      border: 1px solid #286fe8;
      color: #286fe8;
    }

    &.fail {
      border: 1px solid #e6a23c;
      color: #e6a23c;
    }

    &.default {
      border: 1px solid #67c23a;
      color: #67c23a;
    }
  }


  .opple-ability-ui-com-info {
    width: 218px;
    margin-right: 68px;
  }
  .box_reset_size{
    width: 400px;
    margin-right: 0px;
  }

}

</style>
